import request from '@/utils/request'

// 分页查询咨询预约单
export function pageEduConsult(data) {
  return request({
    url: '/biz/admin/edu/consult/page',
    method: 'post',
    data: data
  })
}

// 咨询预约单详情
export function getEduConsult(data) {
  return request({
    url: '/biz/admin/edu/consult/detail',
    method: 'post',
    data: data
  })
}

// 咨询预约单状态流转
export function handleEduConsult(data) {
  return request({
    url: '/biz/admin/edu/consult/handle',
    method: 'post',
    data: data
  })
}
